import { defineComponent as _defineComponent } from 'vue'
import { fetchUserPermission } from '@/apis/auth'
import GBaseModal from '@/components/g-base-modal.vue'
import store from '@/store'
import { translate } from '@/util/commonFun'
import {
  buryPointApi,
  genUniId,
  verifyInputNumber,
} from '@/util/commonFuncs.js'
import { webId } from '@/util/configure'
import { message } from 'ant-design-vue'
import { computed, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-setting-options',
  props: {
    line_item: { default: () => ({}) },
    line_index: null,
    isShowCuttingMachineSettings: { type: Boolean, default: false },
    isShowFiveSixSettings: { type: Boolean, default: false },
    isShowSideHoleSettings: { type: Boolean, default: false },
    isShowIntegrateDoorWallCabinetSettings: { type: Boolean, default: false },
    orderEquipment: { default: 'sideHoleDrill' },
    isShowHoleSlot: { type: Boolean, default: false },
    isShowCombinedFiveSix: { type: Boolean, default: false },
    isShowCombinedPTP: { type: Boolean, default: false },
    isShowCombinedSideHole: { type: Boolean, default: false },
    isAioAndDock56HoleSlotShuntAuth: { type: Boolean, default: false }
  },
  emits: ['update:line_item', 'changeWay'],
  setup(__props: any, { emit: emits }) {

const props = __props as { line_item: { [key: string]: any }, line_index: number, isShowCuttingMachineSettings: boolean, isShowFiveSixSettings: boolean, isShowSideHoleSettings: boolean, isShowIntegrateDoorWallCabinetSettings: boolean, orderEquipment: string, isShowHoleSlot: boolean, isShowCombinedFiveSix: boolean, isShowCombinedPTP: boolean, isShowCombinedSideHole: boolean, isAioAndDock56HoleSlotShuntAuth: boolean }

const hasSideHoleMachineFrontMillInfoAndAlsAuth = ref(false)
onMounted(() => {
  fetchUserPermission({
    permission_type: 'side_hole_machine_front_mill_info_and_als',
  }).then((res) => {
    if (res.status === 1) {
      hasSideHoleMachineFrontMillInfoAndAlsAuth.value = res.data.enable
    }
  })
})
const materialModalVisible = ref(false)
const desMaterialKeyword = ref('')

const handleAddMaterialKeyword = () => {
  if (line_item.value.material_keywords_list.length >= 20) {
    message.error('最多可添加20个关键词')
    return
  }
  materialModalVisible.value = true
}
const handlerDeleteMaterialKeyword = (idx: number) => {
  line_item.value.material_keywords_list.splice(idx, 1)
}
const handleOk = () => {
  if (desMaterialKeyword.value.trim()) {
    line_item.value.material_keywords_list.push(desMaterialKeyword.value)
    desMaterialKeyword.value = ''
    materialModalVisible.value = false
  } else {
    message.error('请输入关键词')
  }
}
const handleInput = (e: any) => {
  desMaterialKeyword.value = e.target.value.slice(0, 30)
}



const line_item = computed({
  get: () => {
    return props.line_item
  },
  set: (value) => emits('update:line_item', value),
})
const userInfo = computed(() => store.state.userInfo)

const isShowHoleShunt = (lineItem: any) => {
  return lineItem.cureList.some(
    (item: any) =>
      item.show && (item.value === 'fiveSix' || item.value === 'ptp')
  )
}
const cureCheckList = [
  {
    name: 'lineManager.onlyCut',
    value: 'noHoleSlot',
  },
  {
    name: 'lineManager.onlyFrontHoleSlot',
    value: 'frontHoleSlot',
  },
  {
    name: 'lineManager.onlyHoleSlot',
    value: 'doubleHoleSlot',
  },
]
const holeSlotKeys = [
  {
    key: 'HINGESCREW',
    label: 'common.hinge',
  },
  {
    key: 'HANGER',
    label: 'common.clothole',
  },
  {
    key: 'STRENTCH',
    label: 'common.stretcher',
  },
  {
    key: 'BP',
    label: 'common.backPlank',
  },
  {
    key: 'ALS',
    label: 'common.ALS',
  },
  {
    key: 'METAL',
    label: 'common.doorSlot',
  },
  {
    key: 'DMBS',
    label: 'common.drawerSlot',
  },

  {
    key: 'KUCHOU',
    label: 'common.KC',
  },
  {
    key: 'YXJ',
    label: 'common.stealth',
  },

  {
    key: 'gratingSlot',
    label: 'common.gratingSlot',
  },
  {
    key: 'lightSlot',
    label: 'common.lightSlot',
  },
  {
    key: 'LKYXJ',
    label: 'common.lkSlot',
  },
  {
    key: 'bull_horn_handle',
    label: 'common.millInfo',
  },
  {
    key: 'haitang_corner',
    label: 'common.haiTang',
  },
  {
    key: 'holes_in_yixing',
    label: 'common.allHole',
  },
  {
    key: 'slots_in_yixing',
    label: 'common.allSlot',
  },
  {
    key: 'hole_slot_in_free_yixing',
    label: 'common.freedomAllHoleSlot',
  },
]
const specialSettingOptions = [
  { lable: 'lineManager.onlyFrontSide', value: 'front' },
  { lable: 'lineManager.onlyBackSide', value: 'back' },
  { lable: 'lineManager.bothFrontBack', value: 'front_back' },
]
const rangeOptions = [
  { lable: 'lineManager.less', value: '<' },
  { lable: 'lineManager.greater', value: '>' },
  { lable: 'lineManager.equal', value: '=' },
]
const conditionOptions = [
  { lable: 'lineManager.and', value: 'and' },
  { lable: 'lineManager.or', value: 'or' },
]
const aioSpecialSettingOptions = [
  { lable: 'lineManager.onlyFrontSide', value: 'front' },
  // { lable: '仅加工反面', value: 'back' },
  // { lable: '加工正面和反面', value: 'front_back' },
]
const aioHoleSlotKeys = [
  {
    key: 'ALS',
    label: 'common.ALS',
  },
  {
    key: 'BP',
    label: 'common.backPlank',
  },
  {
    key: 'METAL',
    label: 'common.doorSlot',
  },
  {
    key: 'DMBS',
    label: 'common.drawerSlot',
  },
  {
    key: 'STRENTCH',
    label: 'common.stretcher',
  },
  {
    key: 'gratingSlot',
    label: 'common.gratingSlot',
  },
]
const cuttingSettingOptions = [
  {
    value: 0,
    label: 'lineManager.noGen',
    key: 'noGen',
  },
  {
    value: 1,
    label: 'lineManager.genCut',
    key: 'genCut1',
  },
  {
    value: 2,
    label: 'lineManager.genNoCut',
    key: 'genNoCut',
  },
]
const specialSlots = [
  {
    value: false,
    label: 'lineManager.normalSlot',
  },
  {
    value: true,
    label: 'lineManager.specialSlot',
  },
]
const holeSlotTypeList = [
  { value: 'hole_slot', label: '孔和槽' },
  { value: 'holes', label: '孔' },
  { value: 'slots', label: '槽' },
  { value: '', label: '空' },
] as any
const isShowFiveSixComputed = computed((line_item) => {
  return props.isShowFiveSixSettings || line_item.activeCureEquip === 'fiveSix'
})
function translateLang(key: string) {
  return translate(key)
}
function handleChangeWay(cure: string, lineIndex: number) {
  // 调用父组件的方法
  emits('changeWay', { cure, lineIndex })
}
const keyName = {
  special_hole_slot: {
    HINGESCREW: '铰链孔',
    HINGE: '铰链孔',
    HANGER: '衣通孔',
    STRENTCH: '拉直器槽',
    BP: '背板槽',
    ALS: '暗拉手槽',
    METAL: '门板金属条槽',
    DMBS: '抽屉金属条槽',
    in_range_all: '允许短边尺寸',
    KUCHOU: '裤抽孔',
    YXJ: '隐形件',
    LKYXJ: '乐扣槽',
    holes_in_yixing: '异形板上所有孔',
    slots_in_yixing: '异形板所有槽',
    bull_horn_handle: '牛角拉手',
    lightSlot: '灯槽',
    haitang_corner: '海棠角',
    range_list: '允许短边尺寸',
    hole_slot_in_free_yixing: '自由异形板上所有孔槽',
  },
  special_hole_slot_way: {
    HINGESCREW: '铰链孔',
    HINGE: '铰链孔',
    HANGER: '衣通孔',
    STRENTCH: '拉直器槽',
    BP: '背板槽',
    ALS: '暗拉手槽',
    METAL: '门板金属条槽',
    DMBS: '抽屉金属条槽',
    in_range_all: '允许短边尺寸',
    KUCHOU: '裤抽孔',
    YXJ: '隐形件',
    LKYXJ: '乐扣槽',
    holes_in_yixing: '异形板上所有孔',
    slots_in_yixing: '异形板所有槽',
    bull_horn_handle: '牛角拉手',
    lightSlot: '灯槽',
    hole_slot_in_free_yixing: '自由异形板上所有孔槽',
  },
  engraving_process_setting: {
    allow_turn_plate_process: 'lineManager.specialHS',
    dock56_drill_still_process: 'lineManager.engravingCuted',
    non_hole_slot_of_special_shape: 'lineManager.engravingPath',
    short_edge_range: 'lineManager.maxShortSize',
    long_edge_range: 'lineManager.maxLongSize',
    curve_range: 'lineManager.curve_range',
    special_shape_processing_in_dock56: 'lineManager.engravingCutedSpecial',
  },
} as any
function dealKeyName(obj: string, key: string) {
  return keyName[obj][key] ? translate(keyName[obj][key]) : 'error'
}
// 验证输入框输入, 新增需求长边限制允许输入为空，兼容其他使用地方，传入默认参数
function verifyInput(
  val: any,
  obj: any,
  keys: any,
  rule: any,
  isMinus = false,
  min = 0,
  isEmpty = false
) {
  verifyInputNumber(val, obj, keys, rule, isMinus, min, isEmpty)
}
function addHoleSlotRangeList(item: any) {
  if (item.length > 4) {
    return message.error('已达添加上限(5条)')
  }
  item.push({
    in_range_all: false,
    long_edge_range: undefined,
    short_edge_range: 100,
    range_way: 'front_back',
    connection: 'and',
    long_condition: '<',
    short_condition: '<',
    range_type: 'hole_slot',
  })
}
function deleteHoleSlotRangeList(item: any, idx: any) {
  if (item.length <= 1) {
    return message.error(translateLang('lineManager.deleteCheck'))
  }
  item.splice(idx, 1)
}
function addHoleSlot(item: any, key: any) {
  let obj
  if (
    (key == 'aio_holes_range' || key == 'aio_slots_range') &&
    !(item[key].length < 20)
  ) {
    message.error('已达添加上限(20条)')
    return
  }
  if (key == 'engraving_holes_range' || key == 'aio_holes_range') {
    obj = {
      minDiameter: 0.0,
      maxDiameter: 0.0,
      minDepth: 0.0,
      maxDepth: 0.0,
      item_type: 'hole',
      [webId]: genUniId(),
    }
  } else {
    obj = {
      minWidth: 0.0,
      maxWidth: 0.0,
      minDepth: 0.0,
      maxDepth: 0.0,
      item_type: 'slot',
      [webId]: genUniId(),
    }
  }
  item[key].push(obj)
}
function deleteHoleSlot(item: any, key: any, idx: any) {
  if (item[key].length <= 1) {
    return message.error(translateLang('lineManager.deleteCheck'))
  }
  item[key].splice(idx, 1)
}
function handleHoleSlotChange(
  setItem: any,
  lineItem: any,
  isChangeWay = false
) {
  if (isChangeWay) return
  // 铰链孔
  if (setItem.key == 'HINGESCREW') {
    lineItem.hole_slot_engraving_process.special_hole_slot['HINGE'] =
      lineItem.hole_slot_engraving_process.special_hole_slot['HINGESCREW']
  }
  // 如果设备选择了侧孔机，修改雕刻机的铰链孔勾选项
  if (
    props.isShowCombinedSideHole &&
    lineItem.hole_slot_engraving_process.special_hole_slot['HINGE']
  ) {
    // 取消侧孔机的勾选
    lineItem.side_machine_hole_slot.HINGE = false
  }
  // 如果设备选择了侧孔机，修改雕刻机的拉直器槽选项
  if (
    props.isShowCombinedSideHole &&
    lineItem.hole_slot_engraving_process.special_hole_slot['STRENTCH']
  ) {
    // 取消侧孔机的勾选
    lineItem.side_machine_hole_slot.STRENTCH = false
  }
  if (
    (setItem.key === 'holes_in_yixing' ||
      setItem.key === 'slots_in_yixing' ||
      setItem.key === 'hole_slot_in_free_yixing') &&
    lineItem.activeCureEquip === 'fiveSix'
  ) {
    if (lineItem.hole_slot_engraving_process.special_hole_slot[setItem.key]) {
      let dom = document.querySelector(
        `#toast_${setItem.key}_${lineItem.id}`
      ) as any
      dom.style.display = 'block'
      if (setItem.key === 'holes_in_yixing') {
        dom.style.left = '-100px'
      }
      let timer = setTimeout(() => {
        dom.style.display = 'none'
        clearTimeout(timer)
      }, 4000)
    }
  }
}
function handleChangeHinge(lineItem: any) {
  if (
    (props.isShowCombinedFiveSix || props.isShowCombinedPTP) &&
    lineItem.side_machine_hole_slot.HINGE
  ) {
    // 取消掉上面的勾选
    lineItem.hole_slot_engraving_process.special_hole_slot['HINGE'] = false
    lineItem.hole_slot_engraving_process.special_hole_slot['HINGESCREW'] = false
  }
}
function handleChangeStrentch(lineItem: any) {
  if (
    (props.isShowCombinedFiveSix || props.isShowCombinedPTP) &&
    lineItem.side_machine_hole_slot.STRENTCH
  ) {
    // 取消掉上面的勾选
    lineItem.hole_slot_engraving_process.special_hole_slot['STRENTCH'] = false
  }
}
function getPopupContainer(triggerNode: HTMLElement | null) {
  return triggerNode?.parentNode as HTMLElement | null
}

// 勾选仅下料
const handleInRangeAllChange = (e: any) => {
  if (e.target.checked) {
    buryPointApi('engraving', 'in_range_all_change')
  }
}

return { __sfc: true,hasSideHoleMachineFrontMillInfoAndAlsAuth, materialModalVisible, desMaterialKeyword, handleAddMaterialKeyword, handlerDeleteMaterialKeyword, handleOk, handleInput, props, emits, line_item, userInfo, isShowHoleShunt, cureCheckList, holeSlotKeys, specialSettingOptions, rangeOptions, conditionOptions, aioSpecialSettingOptions, aioHoleSlotKeys, cuttingSettingOptions, specialSlots, holeSlotTypeList, isShowFiveSixComputed, translateLang, handleChangeWay, keyName, dealKeyName, verifyInput, addHoleSlotRangeList, deleteHoleSlotRangeList, addHoleSlot, deleteHoleSlot, handleHoleSlotChange, handleChangeHinge, handleChangeStrentch, getPopupContainer, handleInRangeAllChange, GBaseModal }
}

})